export default "__VITE_ASSET__BspkW9mY__"